import { appHttpRequest } from '@/utils/AppHttpRequest';
import { IPage } from '@/types/FmsTypes';
import { ISCMPurchaseRoDetail } from './scmPurchaseRoType';
export interface ISCMPage<T, S> extends IPage<T> {
	statistics: S;
}

class PurchaseRoService {
	//采购退货单
	async one(id: string) {
		const apiUrl = `/scm2/purchase/ro/findByIdOrCode/${id}`;
		return await appHttpRequest.get<ISCMPurchaseRoDetail>(apiUrl);
	}
}

export const purchaseRoService = new PurchaseRoService();
